import React from "react";
import { useAdminPriceEdaContext } from "./context";
import cls from "./styles.module.scss";

export const EditorSelectionSummary = () => {
  const {
    selection: { selectedIds },
  } = useAdminPriceEdaContext();

  return (
    <div className={cls.sidebarSection}>
      <div className={cls.sidebarLabel}>Выбор</div>
      <div className={cls.sidebarValue}>
        {selectedIds.length
          ? `Выбрано гексагонов: ${selectedIds.length}`
          : "Ничего не выбрано"}
      </div>
    </div>
  );
};
